import Button from '../components/Button';
import Content from '../components/Content';
import './FreeSite.scss';

const FreeSite = () => {

    return (
        <section className="connect-page">
            <Content
                heading='We now offer starter sites!'
            >
                <p>We often find that clients are tech savvy enough to create their own pages and content layouts throughout their site, but may 
                    lack the technical expertise to get things off the ground. <strong>Starter sites are primarily for do-good startups, individuals, and grassroots nonprofit organizations.</strong>
                </p>
                <br />
                <h2>What comes in a "starter site"?</h2>
                <p>A starter site essentially comes with a fully designed landing page with customized modules. We build our starter sites 
                    using a tool called WordPress which allows you to easily edit content. We do things a bit differently than other places as 
                    we use WordPress more as a tool than to rely on it completely - and we make it easy for you to add content in a way that works for you.
                </p>
                <p>We set everything up for you: from domain purchase to hosting set up, which are included in the cost of 
                    the website - we go straight from "I want a website" to giving you the ability to add content and additional pages.</p>
                <p>The deliverables for a starter site tend to look like this:</p>
                <ul>
                    <li>Domain name attached to your site, ex: www.company.org</li>
                    <li>Paid hosting plan setup for your site through Hostinger</li>
                    <li>Integrations to existing data collection tools (if possible)</li>
                    <li>Full WCAG AA accessibility compliance and mobile responsiveness in site design</li>
                    <li>Fully functional one page site with a header, footer, navigation, and standard modules (see below)</li>
                    <li>A one-hour training to go over WordPress and administration of domain/DNS + hosting panel</li>
                    <li>Optional: Full Google Workspace setup (email, drive, etc.) + the additional cost of users</li>
                </ul>
                <p>Standard modules include:</p>
                <ul>
                    <li>Content module: for adding rich text content, paragraphs, headers, etc.</li>
                    <li>Image module: for adding images</li>
                    <li>Columns module: for displaying a combination of content and image modules in columns</li>
                    <li>Hero module: a cover/hero banner you can put text over, usually at the top of pages</li>
                    <li>Forms module: create forms to collect feedback or contact info on your site</li>
                    <li>Call to Action module: callout text with an optional call to action button</li>
                    <li>Donation module (if needed): link with existing donations platform</li>
                </ul>
                <p>Starter sites start as low as <b>$150*</b>. Submit an inquiry to get started.</p>
                <Button label='Submit an inquiry' href='https://bit.ly/MBCStarter' variation='secondary'/>
                <p>
                    * Note: that this rate is not guaranteed but we do our best to keep things as cheap as possible for you. For projects we 
                    are particularly passionate about we often do them pro bono. Please note your budget when reaching out.
                </p>
            </Content>
        </section>
    )
}

export default FreeSite;